<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("edit") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateForm">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 py-0">
              <upload-image-direct
                @inputChanged="uplodeImg_1"
                model="places"
                :data_src="data.image_preview"
                placeHolder="الصورة"
              ></upload-image-direct>
              <!-- End:: Image -->
            </div>
            <!-- Start:: Image -->
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="button_style_1" :disabled="btnIsLoading">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",
  props: ["id"],
  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.googlePlace.title"),
          disabled: false,
          href: "/googlePlace/show-all",
        },
        {
          text: this.$t("breadcrumb.googlePlace.edit"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== Data To Send
      data: {
        image_preview: null,
        avatar: null,
      },
    };
  },

  methods: {
    // ============ Get Select Lists Data
    // Uplode Image
    uplodeImg_1(obj) {
      this.data.avatar = obj;
    },

    // Validate Data
    validateForm() {
      this.btnIsLoading = true;
      if (!this.data.avatar) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.image"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      if (this.data.avatar) {
        submit_data.append("image", this.data.avatar);
      }

      submit_data.append("_method", "PUT");
      this.$axios({
        method: "POST",
        url: `place/${this.id}/update_image`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/googlePlace/show-all" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    getData() {
      this.$axios.get(`show_place/${this.id}`).then((res) => {
        this.data.image_preview = res.data.place.icon;
      });
    },

    // Empty Form Data
    emptyFormData() {
      this.data.avatar = null;
    },
  },

  created() {
    // Start:: Fire Methods
    this.getData();
    // End:: Fire Methods
  },
};
</script>
